import {
  createActions,
  createReqReducer,
  createReqWatcher,
  createReqConsts,
  initialState as rootState,
} from '../../utils/redux/index';

export const consts = createReqConsts('complaints', 'resolve', ['RESET']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'complaints',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'resolutions',
  ],
});

const initialState = {
  ...rootState,
  data: undefined,
};

const defaultRequestReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  switch (action.type) {
    case consts.RESET: {
      return initialState;
    }

    default:
      return defaultRequestReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/complaints/resolveComplaint.js